//Effects
import { all, put, select, takeLatest } from 'redux-saga/effects';

import {
  ADD_OFFICE_ASSIGNEE,
  ADD_OFFICE_ASSIGNEE_FAILURE,
  ADD_OFFICE_ASSIGNEE_SUCCESS,
  CREATE_OFFICE,
  CREATE_OFFICE_FAILURE,
  CREATE_OFFICE_SUCCESS,
  GET_OFFICES_LIST,
  GET_OFFICES_LIST_FAILURE,
  GET_OFFICES_LIST_SHORT,
  GET_OFFICES_LIST_SHORT_FAILURE,
  GET_OFFICES_LIST_SHORT_SUCCESS,
  GET_OFFICES_LIST_SUCCESS,
  REMOVE_OFFICE_ASSIGNEE,
  REMOVE_OFFICE_ASSIGNEE_FAILURE,
  REMOVE_OFFICE_ASSIGNEE_SUCCESS,
  UPDATE_OFFICE,
  UPDATE_OFFICE_FAILURE,
  UPDATE_OFFICE_SUCCESS,
} from '../../modules/constants';
//Service
import { defaultApi } from '../../utils/axiosApi';

export function* handleGetOfficesList({ payload }) {
  const { page, office_name } = payload;
  try {
    const url = `/albait/offices/${page ? `?page=${page}` : ''}${
      office_name
        ? page
          ? `&name=${office_name}`
          : `?name=${office_name}`
        : ''
    }`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_OFFICES_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_OFFICES_LIST_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetOfficesShortList({}) {
  // const { } = payload;
  try {
    const url = `/albait/offices/short/`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_OFFICES_LIST_SHORT_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_OFFICES_LIST_SHORT_FAILURE,
      payload: err,
    });
  }
}

export function* handleCreateOffice({ payload }) {
  try {
    const url = `/albait/offices/`;
    const response = yield defaultApi(url, 'POST', payload);
    yield put({
      type: CREATE_OFFICE_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: CREATE_OFFICE_FAILURE,
      payload: err,
    });
  }
}

export function* handleUpdateOffice({ payload }) {
  const { office_id, ...data } = payload;
  try {
    const url = `/albait/offices/${office_id}/`;
    const response = yield defaultApi(url, 'PUT', data);
    yield put({
      type: UPDATE_OFFICE_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: UPDATE_OFFICE_FAILURE,
      payload: err,
    });
  }
}

export function* handleAddOfficeAssignee({ payload }) {
  const { office_id, ...data } = payload;
  try {
    const url = `/albait/offices/${office_id}/assignees/`;
    const response = yield defaultApi(url, 'POST', data);
    yield put({
      type: ADD_OFFICE_ASSIGNEE_SUCCESS,
      payload: { office_id, data: response },
    });
  } catch (err) {
    yield put({
      type: ADD_OFFICE_ASSIGNEE_FAILURE,
      payload: err,
    });
  }
}

export function* handleRemoveOfficeAssignee({ payload }) {
  const { office_id, assignee_id } = payload;
  try {
    const url = `/albait/offices/${office_id}/assignees/${assignee_id}`;
    const response = yield defaultApi(url, 'DELETE');
    yield put({
      type: REMOVE_OFFICE_ASSIGNEE_SUCCESS,
      payload: { office_id, assignee_id, data: response },
    });
  } catch (err) {
    yield put({
      type: REMOVE_OFFICE_ASSIGNEE_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    // Get tasks list
    takeLatest(GET_OFFICES_LIST, handleGetOfficesList),
    takeLatest(GET_OFFICES_LIST_SHORT, handleGetOfficesShortList),
    takeLatest(CREATE_OFFICE, handleCreateOffice),
    takeLatest(UPDATE_OFFICE, handleUpdateOffice),
    takeLatest(ADD_OFFICE_ASSIGNEE, handleAddOfficeAssignee),
    takeLatest(REMOVE_OFFICE_ASSIGNEE, handleRemoveOfficeAssignee),
  ]);
}
